import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { closeMaxWebApp, getMaxBridge, signalMaxReady } from '../lib/maxWebApp';
import { navigateToSupportHome } from '../lib/supportNav';

/** Wires MAX BackButton: home → close mini-app, inner pages → back to list. */
export function MaxChrome() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    signalMaxReady();
  }, []);

  useEffect(() => {
    const bridge = getMaxBridge();
    const back = bridge?.BackButton;
    if (!back?.show || !back?.onClick) return;

    const isHome = location.pathname === '/' || location.pathname === '';

    back.show();
    back.onClick(() => {
      if (isHome) {
        closeMaxWebApp();
        return;
      }
      navigateToSupportHome(navigate, location);
    });

    return () => {
      try {
        back.hide?.();
      } catch {
        // ignore
      }
    };
  }, [location, navigate]);

  return null;
}
